import {ReportBuilderAppShell, reportBuilderStore} from "@amzn/fin-press-report-builder-ui";
import React from "react";
import {Provider, useSelector} from "react-redux";
import {Outlet, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Roles} from "src/common/roles";
import {useReportBuilderBreadcrumbs} from "src/features/breadcrumbs/hooks/useReportBuilderBreadcrumbs";
import {getAssumedRole, getUser} from "src/reducers/user.reducer";

export const ReportBuilderScreen = () => {
    const navigate = useNavigate();

    const role = useSelector(getAssumedRole);
    const user = useSelector(getUser);

    const {workflowId, reportUrlId, operationId} = useParams();

    const [searchParams, _] = useSearchParams();

    const versionId = searchParams.get('versionId');

    const breadcrumbContext = useReportBuilderBreadcrumbs();

    return (
        <Provider store={reportBuilderStore}>
            <ReportBuilderAppShell
                workflowVersion={versionId || undefined}
                role={role || Roles.UNKNOWN}
                user={user}
                workflowId={workflowId}
                reportUrlId={reportUrlId}
                operationId={operationId}
                navigate={navigate}
                breadcrumbContext={breadcrumbContext}
            >
                <Outlet/>
            </ReportBuilderAppShell>
        </Provider>
    )
}
